/**
 * Account Deletion Service
 * Used by public account deletion page (for App Store requirements)
 */

import { IS_MOCK, MOCK_DELAY } from '../../constants/config';
import { apiService } from '../api/ApiService';

export interface DeleteAccountRequest {
  email: string;
  password: string;
}

export class AccountDeletionService {
  static async deleteAccount(request: DeleteAccountRequest): Promise<void> {
    if (IS_MOCK) {
      // In mock mode, simulate a successful deletion after delay
      await new Promise((resolve) => setTimeout(resolve, MOCK_DELAY));
      return;
    }

    const response = await apiService.post<{
      isSuccess: boolean;
      message?: string;
    }>('/auth/delete-account', request);

    if (!response.isSuccess) {
      throw new Error(response.message || 'Failed to delete account');
    }
  }
}

